<template lang="pug">
  .address-edit-form
    .row
      .xs-6
        mr-input(label="First Name" v-model="first_name" :v="v.editAddressForm.first_name" autocomplete="shipping given-name" required dataMrAss="shipping-firstname").pr-5

      .xs-6
        mr-input(label="Last Name" v-model="last_name" :v="v.editAddressForm.last_name" autocomplete="shipping family-name" required dataMrAss="shipping-lastname").pl-5

    .row
      .xs-12
        mr-input(label="Street 1" v-model="street_1" :v="v.editAddressForm.street_1" autocomplete='shipping address-line1' required dataMrAss="shipping-address1")

    .row
      .xs-12(v-if="street_2 && street_2.length || showAddressTwo")
        mr-input(label="Street 2" v-model="street_2" autocomplete='shipping address-line2' required dataMrAss="shipping-address2")
      .xs-12(v-else)
        button(type="button" @click="showAddressTwo = true" data-mr-ass="show-address2").btn-link.transparent-btn.xs-f-small.max-at-tweak.color-mr-purple.capitalize.show-address-btn
          i.icon-pos-circle.xs-f-xmedium.max-at-tweak
          | &nbsp;Address Line 2

    .row
      .xs-12
        mr-input(label="Zip Code" v-model="post_code" :v="v.editAddressForm.post_code" autocomplete='shipping postal-code' required dataMrAss="shipping-zip")

    .row
      .xs-12
        mr-input(label="City" v-model="city" :v="v.editAddressForm.city" autocomplete='shipping address-level2' required dataMrAss="shipping-city")

    .row
      .xs-4
        dropdown(label="State" v-model="region" :v="v.editAddressForm.region" required v-if="regions.length" autocomplete='shipping address-level1' dataMrAss="shipping-state").mr-5
          option(v-for="reg in regions" :value="reg.code" :key="reg.code") {{ reg.code }}

      .xs-8(v-if="!isBillingAddress")
        mr-phone-input(label="Phone" input-type="tel" v-model="phone" :v="v.editAddressForm.phone" autocomplete='shipping tel' dataMrAss="shipping-phone").ml-5
        
    .row.default-shipping(v-if="showDefaultAddressCheckbox")
      .xs-12
        .checkbox-wrap.mt-5.mb-5
          mr-input-checkbox(v-model="is_default_shipping", label="Default shipping address" dataMrAss="default-shipping-address")
  
</template>

<script>
  import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
  import mrInputCheckbox from "../mrInputCheckbox";
  import mrInput from '../mrInput';
  import mrPhoneInput from '../mrPhoneInput.vue';

  export default {
    name: "AddressEditInputs",
    components: {
      mrInputCheckbox,
      mrInput,
      mrPhoneInput
    },

    props: ['v'], //- has to contain 'editAddressForm' passed down from
                  //- parent form for proper validation
    data() {
      return {
        showAddressTwo: false
      }
    },

    beforeCreate() {
      this.$store.dispatch('subscriptions/initSubscriptions');
    },

    created() {
      this.$store.dispatch('addressBook/getRegionsByCountry');
    },

    methods: {
      ...mapMutations('addressBook', [
        'updateFirstName',
        'updateLastName',
        'updateStreet1',
        'updateStreet2',
        'updateCity',
        'updateRegion',
        'updatePhone',
        'updateDefaultShipping',
        'updateAddressForSubs',
        'updateUseAddressForAllSubs'
      ]),

      ...mapActions('addressBook', [
        'updatePostCodeWithZipCheck'
      ])
    },

    computed: {
      ...mapGetters('addressBook', [
        'showDefaultAddressCheckbox'
      ]),

      ...mapState('addressBook', [
        'regions',
        'editAddressForm'
      ]),

      first_name: {
        get() {
          return this.editAddressForm.first_name;
        },

        set(value) {
          this.updateFirstName(value);
        }
      },

      last_name: {
        get() {
          return this.editAddressForm.last_name;
        },

        set(value) {
          this.updateLastName(value);
        }
      },

      street_1: {
        get() {
          return this.editAddressForm.street_1;
        },

        set(value) {
          this.updateStreet1(value);
        }
      },

      street_2: {
        get() {
          return this.editAddressForm.street_2;
        },

        set(value) {
          this.updateStreet2(value);
        }
      },

      post_code: {
        get() {
          return this.editAddressForm.post_code;
        },

        set(value) {
          this.updatePostCodeWithZipCheck(value);
        }
      },

      city: {
        get() {
          return this.editAddressForm.city;
        },

        set(value) {
          this.updateCity(value);
        }
      },

      region: {
        get() {
          return this.editAddressForm.region;
        },

        set(value) {
          this.updateRegion(value);
        }
      },

      phone: {
        get() {
          return this.editAddressForm.phone;
        },

        set(value) {
          this.updatePhone(value);
        }
      },

      use_address_for_all_subscriptions: {
        get() {
          return this.editAddressForm.use_address_for_all_subscriptions;
        },

        set(value) {
          this.updateUseAddressForAllSubs(value);
        }
      },

      is_default_shipping: {
        get() {
          return this.editAddressForm.is_default_shipping;
        },

        set(value) {
          this.updateDefaultShipping(value);
        }
      },

      isBillingAddress() {
        return this.editAddressForm.isBillingAddress;
      }
    }
  }
</script>

<style scoped lang="stylus">
  .default-shipping
    margin-bottom 2em

  .submit-btn
    margin-top 2em

  .cancel-btn
    margin-top 0.6em

  .show-address-btn
    padding 0

</style>